<template>
  <div class="mt-2 mx-0 px-0">
    <v-layout class="mx-0 px-0" row wrap v-if="list.length">
      <v-flex xs12 sm12>
        <v-container :class="[$vuetify.breakpoint.width > 959 ? 'ma-0 pa-0' : '']" grid-list-sm grid-list-md grid-list-lg>
          <v-layout row wrap>
            <v-flex
              v-for="(screener, index) in list"
              :key="screener.id"
              xs12
              sm6
              md3
              :class="[
                $vuetify.breakpoint.width < 959 && index >= 2
                  ? 'ma-0 pa-0'
                  : null,
              ]"
            >
              <template
                v-if="
                  ($vuetify.breakpoint.width < 959 && index < 2) ||
                    ($vuetify.breakpoint.width > 959 && index < 8)
                "
              >
                <v-hover>
                  <v-card
                    slot-scope="{ hover }"
                    :class="`elevation-${hover ? 12 : 2}`"
                    class="cursor-pointer"
                    :key="screener.title + index"
                    style="height: 100%"
                    @click.stop="goToScreenerOverview(screener)"
                  >
                    <!-- Show thumbnail of screener -->
                    <v-img
                      v-if="screener.thumbnail_url"
                      class="white--text"
                      height="200px"
                      :src="screener.thumbnail_url"
                    >
                      <!-- Reserved checkmark -->
                    </v-img>
                    <!-- Show thumbnail of first film if thumbnail is not available on screener -->
                    <v-img
                      v-else-if="screener.films[0].thumburls"
                      class="white--text"
                      height="200px"
                      :src="screener.films[0].thumburls"
                    >
                    </v-img>
                    <v-card-title>
                      <div>
                        <div class="pb-2" v-if="!is_vod">
                          <span
                            v-if="screener.is_vod_event"
                            class="secondary--text text--lighten-2"
                          >
                            <span v-if="screener.venue" class="px-1"
                              >|&nbsp;</span
                            >
                            <span>{{ screener.venue }}</span>
                          </span>
                          <span v-else class="secondary--text text--lighten-2">
                            {{
                              moment
                                .utc(screener.screening_starts_at)
                                .local()
                                .format("lll")
                            }}
                            <span class="px-1" v-if="screener.venue"
                              >|&nbsp;</span
                            >
                            <span>{{ screener.venue }}</span>
                          </span>
                          <!-- Alert for geo-blocking -->
                          <v-tooltip
                            top
                            v-if="screener.is_geo_blocked"
                            color="primary"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="error" class="px-1"
                                >mdi-alert</v-icon
                              >
                            </template>
                            <span class="background--text body-1">
                              {{ $t(`${eventPrefix}.geo_blocked`) }}
                            </span>
                          </v-tooltip>
                        </div>

                        <span
                          style="line-height: 1.35 !important"
                          class='title mb-1 cursor-pointer underline-on-hover secondary--text'
                          @click.stop="goToScreenerOverview(screener)"
                          >{{ screener.title }}
                        </span>
                        <!-- Seats Status -->
                        <div
                          v-if="
                            !screener.is_vod_event &&
                              !isArchiveMenu &&
                              !is_past
                          "
                        >
                          <v-chip small outline color="" class="ma-0">
                            <span
                              class="body-2"
                              v-html="getSeatsStatus(screener)"
                            ></span
                          ></v-chip>
                          <span
                            v-if="
                              !screener.is_vod_event &&
                                screener.event_type >
                                  DEFINES.SCREENER_TYPE_VALUE.VIRTUAL
                            "
                            ><v-chip
                              small
                              outline
                              color="primary"
                              class="my-0 ml-1"
                              ><span class="body-2">{{
                                DEFINES.SCREENER_TYPE_STR[screener.event_type]
                              }}</span></v-chip
                            >
                          </span>
                        </div>
                      </div>
                    </v-card-title>
                  </v-card>
                </v-hover>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { getSeatsStatus } from "@/mixins/screening";

export default {
  name: "List",
  data() {
    return {
      dialog: false,
      screener: null,
      pricingPlan: null,
    };
  },
  props: {
    list: {
      default: null,
    },
    is_past: {
      type: Boolean,
      default: false,
    },
    is_vod: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [getSeatsStatus],
  computed: {
    isArchiveMenu: function() {
      return this.$route.name == "screeners.archive";
    },
    eventPrefix() {
      return this.$route.name == "vod.movies" ? "vod" : "screener";
    },
  },
  methods: {
    goToScreenerOverview(screener) {
      if(screener && screener.domain){
        var eventURL = screener.domain+'/screeners/'+screener.id;
        window.open(eventURL);
      }
    },
    goToWatchPage(screener) {
      this.$router.push({
        name: "screeners.watch",
        params: {
          screener_id: screener.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.underline-on-hover:hover {
  border-bottom: 2px solid var(--v-secondary-base);
}
</style>
